import formatLongDate from '@UI/Helpers/formatLongDate';

/** The notice of an archived dossier: dated once its purge is approaching, plain otherwise. */
const describeArchivedDossier = (isPurgeApproaching: boolean, purgeScheduledAt: Date | null): string => {
	if (isPurgeApproaching && purgeScheduledAt !== null) {
		return `Ce dossier archivé sera supprimé définitivement le ${formatLongDate(purgeScheduledAt.toISOString())}, au terme de sa durée de conservation.`;
	}

	return 'Ce dossier est archivé.';
};

export default describeArchivedDossier;
